import Alpine from 'alpinejs';

import intersect from '@alpinejs/intersect';
import validate from '@colinaut/alpinejs-plugin-simple-validate';
import Tooltip from '@ryangjchandler/alpine-tooltip';

import Accordion from './components/accordion';
import AsyncForm from './components/async-form';
import FilterCities from './components/filter-cities';
import Modal from './components/modal';
import News from './components/news';
import PromotionView from './components/promotion-view';
import SearchInternet from './components/search-internet';
import TarifOptionsCarousel from './components/tarif-options-carousel';
import TvPackages from './components/tv-packages';
import VimeoPlayer from './components/vimeo-player';

window.Alpine = Alpine;

Alpine.plugin(intersect);
Alpine.plugin(validate);
Alpine.plugin(Tooltip);

Alpine.data('accordion', Accordion);
Alpine.data('asyncForm', AsyncForm);
Alpine.data('filterCities', FilterCities);
Alpine.data('modal', Modal);
Alpine.data('news', News);
Alpine.data('promotionView', PromotionView);
Alpine.data('searchInternet', SearchInternet);
Alpine.data('tarifOptionsCarousel', TarifOptionsCarousel);
Alpine.data('tvPackages', TvPackages);
Alpine.data('vimeoPlayer', VimeoPlayer);

Alpine.start();
